<template>
  <div class="choose-title-stage">
    <app-filter
      :filter-list="table_filter"
      @search="search"
    />
    <app-table
      ref="table"
      :table-key="table_key"
      :tablep="table_params"
      :is-row-click="false"
      :get-data="getTitleList"
      :check="true"
      @select-tr="onSelectionChange"
    />
  </div>
</template>

<script>
import TitleResource from '@/api/title';
const titleResource = new TitleResource();

export default {
  components: {
    'app-table': () => import('@/components/app-table'),
    'app-filter': () => import('@/components/app-filter'),
  },
  props: {
    pageConfig: {
      type: Object,
      default() {
        return null;
      },
    },
  },
  data() {
    return {
      multiple_selection: [], // 表格多选数据
      table_filter: require('@/views/auxiliary/title/model/table-filter')(this), // 过滤项
      table_key: require('@/views/auxiliary/title/model/table-key')(this).splice(0, 2), // 表头数据
      // 表格请求参数
      table_params: {
        advertiser: '',
        page: 1,
        limit: 10,
      },
    };
  },
  created() {
    Object.assign(this.table_params, { advertiser: this.pageConfig.advertiser });
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 查询参数
     */
    search(params) {
      Object.assign(this.table_params, params);
      this.$refs.table.seekTable();
    },

    /**
     * 获取标题列表
     * @param {Object} params 查询参数
     */
    getTitleList(params) {
      return new Promise((resolve, reject) => {
        titleResource.getApi(params).then(resolve).catch(reject);
      });
    },

    /**
     * 监听表格选择
     * @param {Array} val 选中的数据
     */
    onSelectionChange(val) {
      this.multiple_selection = val;
    },

    /**
     * 获取已选项
     */
    async getAssignSelection() {
      return Promise.resolve(this.multiple_selection);
    },
  },
};
</script>
